import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { IProductsModel } from 'src/app/shared/models/products.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-independent-occupation',
  templateUrl: './independent-occupation.component.html',
  styleUrls: ['./independent-occupation.component.scss'],
})
export class IndependentOccupationComponent implements OnInit {

  @Output() selectedDateChange;

  /**
   * Variable para la información del documento del cliente
   *
   * *Document client info variable*
   *
   * @type {DocumentModel}
   * @access public
   */
  documentInfo: DocumentModel;

  /**
   * Variable para el formulario del componente
   *
   * *Form variable*
   *
   * @type {FormGroup}
   * @access public
   */
  formGroup: FormGroup;

  /**
   * Variable para las opciones de la lista del componente
   *
   * *Options list variable*
   *
   * @type {Array<any>}
   * @access public
   */
  options: any[];

  /**
   * Variable para filtrar las opciones del la lista del componente
   *
   * *Options filtered to component list variable*
   *
   * @type {Array<any>}
   * @access public
   */
  optionsFilter: any[];

  selectedCiiu: any;

  has_second_headline: any;

  reactiveErrorDate = '';

  wrongDate = '';

  selectedDate: string;

  beforeDate: boolean;

  selectedProduct: IProductsModel;

  errorDate: string;

  isBtnDisabled: boolean;

  optionsCiiu: any[];

  selectedGeneral: any;

  enableDetail = false;

  /**
   * Constructor of the component.
   *
   * @param {AbreCuentasService}          abreCuentasService          Injectable abreCuentasService service.
   * @param {ParametersService}           parametersService           Injectable parametersService service.
   * @param {NavigationService}           navigationService           Injectable navigationService angular router.
   * @param {BioCatchSeFormBuilderrvice}  formBuilder                 Injectable formBuilder.
   * @param {TaggingService}              taggingService              Injectable taggingService service.
   * @param {HeaderService}               headerService               Injectable headerService service.
   * @param {CaptureService}              captureService              Injectable captureService service.
   * @param {CopyService}                 copyService                 Injectable copyService service.
   * @function setLoadingSubscribe
   * @function setHeaderSubscribe
   */
  constructor(
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private navigationService: NavigationService,
    private formBuilder: FormBuilder,
    private taggingService: TaggingService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private helperService: HelpersService,
    public copyService: CopyService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
    this.selectedProduct = this.abreCuentasService.getproductSelected();
  }

  /**
   * Ciclo de vida principal del componente, carga la lista CIIU para mostrar
   *
   * *Principal componente life cycle, charges CIIU list to be shown*
   */
  ngOnInit() {
    this.selectedGeneral = {
      ciiu: '',
      description: '',
    };
    this.has_second_headline = this.abreCuentasService.getSecondHeadline();
    this.selectedCiiu = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline)
      ? this.abreCuentasService.getCiiuSelected()
      : this.abreCuentasService.getSecondCiiuSelected();
    this.selectedDate = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline)
      ? this.abreCuentasService.getCiiuDate()
      : this.abreCuentasService.getSecondCiiuDate();
    if (this.selectedDate === undefined) {
      this.selectedDate = '';
    }
    this.formGroup = new FormGroup({
      'input-value-occupation': new FormControl('', [Validators.required, Validators.minLength(4),
        Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/))]),
    });

    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.optionsCiiu = this.parametersService.getSetting(OpEnum.CIIU_GENERAL_LIST);
    this.options = this.parametersService.getSetting(OpEnum.CIIU_LIST) || [];
    this.options = this.options.map(option => ({ ...option, large_description: `${option.ciiu} - ${option.description}` }));
    this.optionsFilter = this.options;
    if (this.selectedProduct.name === 'Saving Account') {
      this.beforeDate = true;
    }
    if (this.selectedCiiu.next || this.selectedCiiu.description !== undefined) {
      this.setSelectedGeneral();
      return;
    }
    this.clearSelectedCiiu();
    this.enableContinue();
  }

  dateValidation() {
    const now = new Date();
    const actual = `${now.getUTCDate()}/${now.getUTCMonth() + 1}/${now.getUTCFullYear()}`;
    const dateValidation = this.helperService.compareDates(actual, this.selectedDate);
    if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline)
        ? this.abreCuentasService.setCiiuDate(this.selectedDate)
        : this.abreCuentasService.setSecondCiiuDate(this.selectedDate);
    }
    if (dateValidation > 0) {
      if (this.abreCuentasService.getproductSelected().product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
        this.selectedCiiu.ciiu === '090' ? this.navigationService.nextStep('201') : this.navigationService.nextStep('200');
        return;
      }
      this.beforeDate = true;
      this.abreCuentasService.setCiiuDate(this.selectedDate);
      this.abreCuentasService.setCiiuSelected(this.selectedCiiu);
      this.callProspectIndependent();
      return;
    }
    const errorInfo = {
      title: '¡Menos de 2 no es suficiente!',
      description: 'Edita la fecha que ingresaste o intenta nuevamente cuando lleves 2 realizando tu actividad',
      buttonLabel: this.copyService.copies.error_back_to_edit_date_end,
      type: 'date',
      buttonAction: '$exit',
    };
    this.abreCuentasService.setErrorProperty(errorInfo);
    this.errorDate = this.copyService.copies.independent_occupation.selected_date_error;
    this.beforeDate = true;
    this.navigationService.nextStep('502');
  }

  callProspectIndependent() {
    this.captureService.sendProspectIndependentOccupation(this.selectedCiiu).then(response => {
      // Con cryptovault solo llega vacio  if (response === "") y sin crypto response === null
      if (response.body === '') {
        this.selectedCiiu.ciiu === '090' ? this.navigationService.nextStep('201') : this.navigationService.nextStep('200');
      }
    }).catch(() => {
      this.navigationService.navigateToGeneralInformation('500');
    });
  }

  /**
   * Servicio de taggeo para enviar datos a Google Analytics
   *
   * *Tag service to send data to Google Analytics*
   *
   * @param {string} tagPageName
   */
  pageTagEvent(tagPageName: string) {
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.header,
          type: EVENT.customCategory.type.tooltip,
          position: EVENT.customCategory.position.top,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E1customLabel`],
      };

      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Acción de cuando el botón de más información es oprimido
   *
   * *Action when 'more info' button is pressed*
   */
  clickInfo() {
    this.taggingService.setTagId('pv38', '', 'pv174', '');
    const tagPageName = this.taggingService.getTagIdByProduct();
    this.pageTagEvent(tagPageName);
  }

  /**
   * Acción cuando una opción es seleccionada
   *
   * *Action when an option is selected*
   *
   * @param option
   */
  selectOption(option: any) {
    if (option.value) {
      this.selectedCiiu = option.value;
      (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline)
        ? this.abreCuentasService.setCiiuSelected(this.selectedCiiu)
        : this.abreCuentasService.setSecondCiiuSelected(this.selectedCiiu);
    } else if (option.isTrusted) {
      (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline)
        ? this.abreCuentasService.setCiiuSelected(this.selectedCiiu)
        : this.abreCuentasService.setSecondCiiuSelected(this.selectedCiiu);
    } else {
      this.clearSelectedCiiu();
    }
    this.enableContinue();
  }

  selectOptionCiiu(ciiuSelected: any) {
    console.log(ciiuSelected);
    if (ciiuSelected.value.ciiu) {
      this.options = this.optionsFilter.filter(option => {
        const ciiu = option.ciiu.length === 3 ? '0' + option.ciiu : option.ciiu;
        return ciiu.substring(0, 2) == ciiuSelected.value.ciiu;
      });
      this.enableDetail = true;
    } else {
      this.enableDetail = false;
      this.clearSelectedCiiu();
      this.enableContinue();
    }
  }

  setSelectedGeneral() {
    const ciiu = this.selectedCiiu.ciiu.length === 3 ? '0' + this.selectedCiiu.ciiu : this.selectedCiiu.ciiu;
    const ciiuCode = ciiu.substring(0, 2);
    this.selectedGeneral = {
      ciiu: ciiuCode,
      description: this.optionsCiiu.filter((option: any) => option.ciiu === ciiuCode)[0].description,
    };
    this.enableDetail = true;
  }

  clearSelectedCiiu() {
    this.selectedCiiu = {
      ciiu: '',
      description: '',
      large_description: '',
      next: false,
      sector_code: 0,
    };
  }

  /**
   * Acción cuando el botón continuar esta habilitado
   *
   * *Action when 'next' button is available*
   */
  next() {
    if (this.selectedProduct.product_type !== BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
      this.dateValidation();
      return;
    }
    this.callProspectIndependent();

  }

  enableContinue() {
    console.log('this.selectedCiiu.ciiu', this.selectedCiiu.ciiu);
    if (this.selectedProduct.flow !== 'savingAccount' &&
      this.selectedProduct.flow !== 'payrollAccount' &&
      this.selectedProduct.flow !== 'ConsultationRequest') {
      if (this.selectedDate && this.selectedCiiu.ciiu) {
        this.isBtnDisabled = true;
      } else {
        this.isBtnDisabled = false;
      }
    } else if (this.selectedCiiu.ciiu) {
      this.isBtnDisabled = true;
    } else {
      this.isBtnDisabled = false;
    }
  }

  validReactiveInput(event: any) {
    let value = (event.target.value as string);
    const regExPattern = /^\d{1,2}\/\d{1,2}\/\d{4,4}$/;
    if (value.match(regExPattern) && value !== '') {
      this.selectedDate = value;
      this.enableContinue();
    } else {
      this.isBtnDisabled = false;
    }
  }

}
